import React from "react";
type LogoProps = {
  size?: "header" | "footer";
};
const LOGO_SRC = "https://cdn.magicpatterns.com/uploads/aTtxauNjyw1i7VGf8YmMPR/Screenshot_2026-10-22_at_9.55.34_PM.png";
export function Logo({
  size = "header"
}: LogoProps) {
  return <img src={LOGO_SRC} alt="Flexhire Solutions LLC — Workforce Support Solutions" width={size === "header" ? 160 : 140} className={`block h-auto shrink-0 ${size === "header" ? "w-[160px]" : "w-[140px]"}`} decoding="async" data-id="element-292" data-mp="3qbea0knbfyxj" />;
}